function changeFontSize(id, size) {
    var target = document.getElementById(id);
    var elements = target.getElementsByTagName('*');
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var style = window.getComputedStyle(element, null).getPropertyValue('font-size');
        var fontSize = parseFloat(style);
        var newFontSize = fontSize + size;
        if (newFontSize < 0) {
            newFontSize = 0;
        }
        element.style.fontSize = newFontSize + "px";
    }
}

export {changeFontSize};

